export default __webpack_public_path__ + "static/media/Wan2.0a16b3c0.png";